module.exports = __webpack_public_path__ + "static/media/Minyan-project.0b7f472a.PNG";